import React, { useState } from 'react'
import { http } from '../../../../utils/clientHttp'
import { useRegionStore } from '../../../../store/regionStore'
import { useRegionCountryCode } from '../../../RegionGeo'
import styles from './styles.module.css'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import InputField from '../../ContactForm/InputField'
import CtaLoading from '../../../CtaLoading'
import CountriesAutocomplete from '../../../MyAutocomplete/CountriesAutocomplete'
import { PALETTE } from '../../../../styles/constants'
import ContactFormSubmittedModal from '../../ContactForm/ContactFormSubmittedModal'
import ContactFormSubmittedAlert from '../../ContactForm/ContactFormSubmittedAlert'

function ContactForm({ selectedOptionIds }) {
  // Region geo migrated off Overmind (Phase C2 part 2): countries/shippingCountry
  // from the Zustand region store; newRegion from the RegionGeo seam.
  const countries = useRegionStore((s) => s.countries)
  const shippingCountry = useRegionStore((s) => s.shippingCountry)
  const newRegion = useRegionCountryCode()

  const [contactForm, updateContactForm] = useState({ name: '', email: '', phone: '' })
  const [isLoading, setIsLoading] = useState(false)
  const [formStatus, setFormStatus] = useState({ ticketId: null, error: false })

  const submitContactForm = () => {
    resetStatus()
    setIsLoading(true)

    http.post('/api/submitTurnkeyOfferRequest', { ...contactForm, countryCode: shippingCountry || newRegion, selectedOptionIds: selectedOptionIds })
      .then((response) => {
        console.log('response', response)
        setFormStatus({ ticketId: response.data.ticketId, error: false })
        resetContactForm()
      })
      .catch((e) => {
        console.log('Bad request', e.message)
        setFormStatus({ ticketId: null, error: true })
        resetContactForm()
      })
  }

  const resetStatus = () => {
    setFormStatus({ ticketId: null, error: false })
  }

  const resetContactForm = () => {
    setIsLoading(false)
    updateContactForm({ name: '', email: '', phone: '' })
  }

  return (
    <div className={styles.contactFormWrapper}>
      <div className={styles.contactFormTitle}>
        <Text type="h3">Contact your VRS® expert</Text>
        <Text type="body-short-1">An experienced rep will contact you as soon as possible to fully customize your simulator. Just leave your info below.</Text>
      </div>
      <form
        className={styles.form}
        onSubmit={(e) => {
          submitContactForm()
          e.preventDefault()
        }}
      >
        <InputField
          labelText={'Name'}
          value={contactForm.name}
          placeholder={'John Doe'}
          required
          onChange={(value) => updateContactForm({ ...contactForm, name: value })}
        />
        <InputField
          labelText={'Email'}
          value={contactForm.email}
          placeholder={'example@example.com'}
          type="email"
          required
          onChange={(value) => updateContactForm({ ...contactForm, email: value })}
        />
        <InputField
          labelText={'Phone'}
          value={contactForm.phone}
          placeholder={'+00 1234567890'}
          onChange={(value) => updateContactForm({ ...contactForm, phone: value })}
        />
        <div className={styles.countriesWrapper}>
          <label>
            <Text type="caption-1">Country</Text>
          </label>
          <div className={styles.autocompleteWrapper}>
            <CountriesAutocomplete
              maxWidth
              transparentBorder
              countries={countries}
              selectedCountryCode={shippingCountry}
              inputTextColor={PALETTE.gray80}
              popupIndicatorColor={PALETTE.gray80}
            />
          </div>
        </div>
        <Spacer size={4}/>
        <CtaLoading
          title="Submit"
          primary
          dark
          type="submit"
          isLoading={isLoading}
          disabled={isLoading}
        />
      </form>
      <ContactFormSubmittedModal
        show={!!formStatus.ticketId}
        message={'We\'ve received your request and sent you an email with a summary.'}
        ticketId={formStatus.ticketId}
        onClose={resetStatus}
      />
      <ContactFormSubmittedAlert
        type="error"
        show={formStatus.error}
        message={'Something went wrong. Please try again. If the error persists, please contact us.'}
        onClose={resetStatus}
      />
    </div>
  )
}

export default ContactForm
